import clsx from "clsx";
import { Oval } from "react-loader-spinner";
import styles from "./styles.module.scss";

export type TButtonVariant =
  | "default"
  | "gray"
  | "transparent"
  | "danger"
  | "dark"
  | "secondary"
  | "map"
  | "lightDark"
  | "lightGreen";

export type TButtonSize = "small" | "default";

export type ButtonProps = {
  label: string;
  className?: string;
  disabled?: boolean;
  variant?: TButtonVariant;
  size?: TButtonSize;
  loading?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  style?: React.CSSProperties;
  isRowRight?: boolean;
  isRowLeft?: boolean;
  img?: { url: string; alt: string };
};

const iconRow = "../icons/icon-arrow-down.svg";

const Button: React.FC<ButtonProps> = (props) => {
  const {
    label,
    variant = "default",
    loading,
    onClick,
    disabled,
    className,
    isRowRight,
    isRowLeft,
    style,
    size,
    img,
  } = props;

  return (
    <button
      style={style}
      type="button"
      onClick={onClick}
      disabled={loading || disabled}
      className={clsx(
        styles.button,
        styles[variant],
        className,
        styles["size_" + size],
        img && styles.button_heightAuto
      )}
    >
      <div className={styles.container}>
        {isRowLeft && (
          <div className={styles.rowContainer}>
            <img
              src={iconRow}
              alt={"icon-row"}
              className={clsx(styles.row, styles.row_left, styles.row_black)}
            />
          </div>
        )}
        <div className={styles.content}>
          {loading && <Oval wrapperClass={styles.spinner} strokeWidth={4} />}
          {label}
        </div>
        {isRowRight && (
          <div className={styles.rowContainer}>
            <img src={iconRow} alt={"icon-row"} className={styles.row} />
          </div>
        )}
      </div>
    </button>
  );
};

export default Button;
